// api/ensureCollab.ts
import { registerMutation } from "@adornis/baseql/metadata/register.js";
import { ensureRoom } from "../server/room-store.js";
var ensureCollab = registerMutation({
  type: () => Boolean,
  operationName: "ensureCollab",
  resolve: (roomID, _class) => {
    return async () => {
      if (!roomID || roomID.length > 128) {
        throw new Error("Room ID is required");
      }
      const room = await ensureRoom(roomID, _class);
      if (!room) {
        return false;
      }
      return true;
    };
  },
  params: [
    {
      name: "roomID",
      type: () => String
    },
    {
      name: "_class",
      type: () => String
    }
  ]
});
export {
  ensureCollab
};
